<template>
  <div class="upload-file">
    <b-upload
      v-model="upload"
      v-bind="$attrs"
      drag-drop
      :multiple="multiple"
      @input="handleUploadFile">
      <v-container fluid>
        <v-row>
          <v-col
            class="d-flex justify-center"
            cols="12">
            <v-icon size="40">
              mdi-upload
            </v-icon>
          </v-col>
        </v-row>
      </v-container>
    </b-upload>
  </div>
</template>

<script>
import { uploadToBucket } from '@/utils/S3'

export default {
  props: {
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      upload: []
    }
  },
  methods: {
    async handleUploadFile (event) {
      let imgSrc = null
      if (this.multiple) {
        for (let i = 0; i < event.length; i++) {
          if (!imgSrc || imgSrc.length === 0) {
            imgSrc = []
          }
          imgSrc.push(uploadToBucket(event[i]))
        }
        imgSrc = await Promise.all(imgSrc)
      } else {
        imgSrc = await uploadToBucket(event)
      }
      this.upload = []

      this.$emit('input', imgSrc)
    }
  }
}
</script>

<style lang='scss'>
.upload-file {
  border-radius: 6px;
  position: relative;
  width: 100%;

  .upload input[type=file] {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    outline: none;
    cursor: pointer;
    z-index: -1;
  }
  .upload {
    display: inline-flex;
    width: 100%;

    .upload-draggable {
      cursor: pointer;
      width: 100%;
      padding: 0.25em;
      border: 1px dashed #b5b5b5;
      border-radius: 6px;
    }
  }
}
.drag-group {
  margin: 0 -15px;
}
.drag-item {
  margin: 0 15px 15px 15px;
  cursor: pointer;
}
.drag-item>.item {
  width: 200px;
  height: 290px;
  background-size: contain;
}
.upload-file.none-file {
  padding: 0;
  border: 0;
}
</style>
